import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('change', '.price-list-selector select', fn.handlePriceList)
  },

  handlePriceList: (e) => {
    const priceList = document.querySelector(`[data-price-list="${e.target.value}"]`)

    if (priceList) {
      document.querySelectorAll('.price-list').forEach((el) => el.classList.add('hidden'))
      priceList.classList.remove('hidden')
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-servicepage'),
  run: fn.init,
}
